import { BackendError } from './base';

class UserHasNoAccessToWorkspaceResource extends BackendError {}
class WorkspaceNotFound extends BackendError {}
class UserAlreadyInvitedForWorkspace extends BackendError {}
class UserAlreadyMemberOfWorkspace extends BackendError {}
class CouldNotCreateInviteForWorkspace extends BackendError {}
class CouldNotAcceptInviteForWorkspace extends BackendError {}
class CouldNotDeclineInviteForWorkspace extends BackendError {}
class CouldNotUpdateWorkspace extends BackendError {}
class CouldNotGetWorkspace extends BackendError {}
class InconsistentWorkspaceAcl extends BackendError {}
class EmailVerificationNeeded extends BackendError {}
class CouldNotGetWorkspaceSurveyControl extends BackendError {}
class CouldNotUpdateWorkspaceSurveyControl extends BackendError {}
class NotEnoughUsageLimit extends BackendError {}
class AdminCantAccessNonReadOnlyResource extends BackendError {}
class CouldNotInvalidateSession extends BackendError {}
class NoWorkspaceInRequest extends BackendError {}

export default {
    UserHasNoAccessToWorkspaceResource,
    WorkspaceNotFound,
    UserAlreadyInvitedForWorkspace,
    UserAlreadyMemberOfWorkspace,
    CouldNotCreateInviteForWorkspace,
    CouldNotAcceptInviteForWorkspace,
    CouldNotDeclineInviteForWorkspace,
    CouldNotUpdateWorkspace,
    CouldNotGetWorkspace,
    InconsistentWorkspaceAcl,
    EmailVerificationNeeded,
    CouldNotGetWorkspaceSurveyControl,
    CouldNotUpdateWorkspaceSurveyControl,
    NotEnoughUsageLimit,
    CouldNotInvalidateSession,
    AdminCantAccessNonReadOnlyResource,
    NoWorkspaceInRequest,
};
